<template>
	<div class="sideBar">
		<ul>
			<router-link tag='li' to='/message' active-class='active' class="item" v-show="decidePower('排水户信息管理')">
				排水户信息管理
			</router-link>
			<router-link tag='li' to='/license' active-class='active' class="item" v-show="decidePower('许可证勘察审批')">
				许可证勘察审批
			</router-link>
			<router-link tag='li' to='/drainage' active-class='active' class="item" v-show="decidePower('排水户检查')">
				排水户检查
			</router-link>
			<router-link tag='li' to='/count' active-class='active' class="item" v-show="decidePower('统计分析')">
				统计分析
			</router-link>
      		<router-link tag='li' to='/system' active-class='active' class="item" v-show="decidePower('配置管理')">
				配置管理
			</router-link>
		</ul>
	</div>

</template>
<script>
	export default {
		name: 'HomeSideBar'
	}
</script>
<style lang='stylus' scoped>
	@import '~@/assets/style/varible.styl';
	.sideBar {
		width: 230px;
		position: relative;
		top: 0px;
		left: 0;
		bottom: 0;
		background-color: $bgColor;
		box-shadow: 0 1px 4px 0 rgba(0,0,0,0.04);
		box-sizing: border-box;
		z-index: 1;
		.item {
			height: 46px;
			line-height: 46px;
			font-size: 14px;
			color: #3E3F42;
			letter-spacing: 0;
			padding-left: 20px;
			cursor: pointer;
			&:hover {
				color: #4285F4;
				border-left: 5px solid #4285F4;
				background-color: rgba(66, 133, 244, .05);
			}
			&.active {
				color: #4285F4;
				border-left: 5px solid #4285F4;
				background-color: rgba(66, 133, 244, .05);
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/home/components/sideBar/sideBar.vue